<template>
  <div v-if="loading">
    <DxLoadPanel :visible="true" :show-indicator="true" :show-pane="true" :shading="false" :hide-on-outside-click="false" />
  </div>
  <div v-else>
    
    <!-- {{ devices}} -->
    <!-- <br><br> -->

    
    <!-- <div v-for="(device, index) in devices" :key="device.deviceId"> -->
    <div v-for="(device) in devices" :key="device.deviceId">
      <DxTextBox class="form-field" label="Id" :read-only="true" v-model:value="device.deviceId" />    
      <DxTextBox class="form-field" label="Name / IMEI" :read-only="true" v-model:value="device.imei" />    
      <DxTextBox class="form-field" label="Install Date" :read-only="true" v-model:value="device.installDate" />
      <DxSelectBox class="form-field" label="Type" :search-enabled="true" :data-source="deviceTypes" value-expr="deviceTypeId" display-expr="deviceTypeName" v-model:value="device.deviceTypeId"/>
      <DxSelectBox class="form-field" label="Contract" :search-enabled="true" :data-source="contracts" value-expr="contractId" display-expr="contractName" v-model:value="device.contractId"/>
      <DxDateBox class="form-field"
        label="Contract Date"
        display-format="yyyy-MM-dd"
        v-model:value="device.contractDate"
        :input-attr="{ 'aria-label': 'Date' }"
        type="date"
      /> 
      <!-- <hr/> -->
       <br />
      <div class="buttons">
        <DxButton style="background-color: #ff7300; width: 50%;" class="saveBtn" icon="save" text="Save" @click="saveDevice"/>
      </div>
    </div>
  </div>  
</template>

<script>

import { DxLoadPanel } from 'devextreme-vue/load-panel'
// import { DxScrollView } from "devextreme-vue/scroll-view";
import DxTextBox from "devextreme-vue/text-box";
import DxSelectBox from 'devextreme-vue/select-box';
import DxButton from 'devextreme-vue/button';
import DxDateBox from 'devextreme-vue/date-box';

export default {
  components: {
    DxLoadPanel,
    // DxScrollView,
    DxTextBox,
    DxSelectBox,
    DxButton,
    DxDateBox
  },
  props: ['containerId', 'container'],
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    devices() {
      var dev = this.$store.getters["devices/getContainerDevices"];
      if (dev == undefined || dev == null)
        return []
      else
        return dev
    },
    deviceTypes() {
      var dt = this.$store.getters["deviceTypes/getDeviceTypes"];
      if (dt == undefined || dt == null)
        return []
      else
        return dt
    },
    contracts() {
      var cont = this.$store.getters["contracts/getContracts"];
      if (cont == undefined || cont == null)
        return []
      else
        return cont
    },
    userInfo() {
      var profile = this.$store.getters["auth/getTokenDetails"];
      if (profile == undefined || profile == null)
        return ""
      else
        return profile
    }
  },
  watch: {
    containerId: function (newId, oldId) {
      this.loadDevices();
    }
  },
  created() { 
    this.loadDevices();
  },
  methods:{
    saveDevice(){
      console.log(this.devices)
      this.$store.dispatch("devices/updateDevicesByContainer", this.devices)
    },
    async loadDevices() {
      this.loading = true
      if (this.container.containerId != null && this.container.containerId !== undefined && this.container.containerId > 0) {
        await Promise.all([
          this.$store.dispatch("devices/loadDevicesByContainer", this.container.containerId),
          this.$store.dispatch("deviceTypes/loadDeviceTypes"), 
          this.$store.dispatch("contracts/loadContracts")
        ])
      }
      console.log("LOAD")
      console.log(this.$store.getters["auth/getTokenDetails"])
      this.loading = false
    },
  }
};

</script>

<style scoped>
.form-field{
  margin-top: 10px;
}
  
</style>
